import CopyableTeamEmail from './CopyableTeamEmail.en';

export default {
	CopyableTeamEmail,
};
